import React from 'react';

export default function Spacer() {
  return <div style={{ flexGrow: 1 }}></div>;
}
